import { useQuery } from "@apollo/client";
import { ApplicantProfileContactView } from "./applicant-profile-contact-view";
import { StaffApplicantProfilePersonalInformationContactContainerDocument } from "../../../../generated";
import { Empty, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";

interface ApplicantProfileContactViewContainerProps {
  applicantId: string;
};

export const ApplicantProfileContactViewContainer: React.FC<ApplicantProfileContactViewContainerProps> = ({applicantId}) => {
  const navigate = useNavigate();


  const {
    data: contactData,
    loading: contactLoading,
    error: contactError,
  } = useQuery(StaffApplicantProfilePersonalInformationContactContainerDocument, {
    variables: {
      applicantUserId: applicantId,
    },
  });

  const handleEdit = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/edit");
    navigate(newPath);
  };

  if (contactLoading) {
    return <Skeleton active />;
  }

  if (
    contactError ||
    !contactData?.applicantUser?.personalInformation?.contactInformation
  ) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  const error = contactError
  const isLoading = contactLoading;
  const hasData =
    contactData?.applicantUser?.personalInformation?.contactInformation !==
    undefined;

  return (
    <ComponentQueryLoader
      error={error}
      loading={isLoading}
      hasData={hasData}
      hasDataComponent={
        <ApplicantProfileContactView
        contactInformation={
          contactData.applicantUser.personalInformation.contactInformation
        }
        onEdit={handleEdit}
      />
      }
    />
  );
};
